<script>
	import { createEventDispatcher } from "svelte";
	const dispatch = createEventDispatcher();

	export let options;
	export let value;
	export let line;

	function selectOption(e) {
		value = e.currentTarget.dataset.id;
		dispatch("change", { value });
	}
</script>

{#each options as option}
	<li class={options.length === 1 ? 'aloneRadio' : ''} class:line>
		<label on:click={selectOption} data-id={option.id}>
			<span class="box" class:selected={value === option.id} />
			<span class="name">{option.name}</span>
		</label>
	</li>
{/each}

<style>
	li {
		margin-top: 1.6rem;
	}
	label {
		vertical-align: top;
		cursor: pointer;
	}
	.line {
		display: inline-block;
		margin: 2rem 2rem;
	}
	.aloneRadio {
		display: block;
		max-width: max-content;
		margin-left: 4rem;
	}
	.box {
		float: left;
		width: 20px;
		height: 20px;
		border: 2px solid rgba(1, 1, 1, 0.5);
		border-radius: 50%;
		position: relative;
		transition: 0.2s all ease-in-out;
		display: block;
	}
	.name {
		font-size: 1.6rem;
		line-height: 2.1rem;
		color: rgba(0, 0, 0, 0.6);
		margin-left: 3rem;
		display: block;
	}
	.box.selected:before {
		content: "";
		display: block;
		width: 10px;
		height: 10px;
		background-color: #7e57c2;
		border: 2px solid #7e57c2;
		border-radius: 50%;
		position: absolute;
		top: 50%;
		left: 50%;
		margin: -5px 0 0 -5px;
	}
	@media screen and (max-width: 420px) {
		.line {
			display: inline-block;
			margin: 1rem;
		}
	}
</style>
